/**
 *
 * @param customerId Client id
 * @returns the correct contact phone of client
 */
export const correctPhone = (customerId: string): string => {
  switch (customerId) {
    case 'MACC':
      return '900 37 47 01'
    case 'CERBERUS':
      return '902 57 06 46'
    case 'ANTICIPA':
      return '902 57 08 39'
    case 'SAREB':
      return '91 196 63 73'
    default:
      return null
  }
}
